import { g as getWindow } from './getWindow-3a67409b.js';
import { g as getDocumentElement } from './getDocumentElement-03ce9e66.js';
import { g as getWindowScrollBarX } from './getWindowScrollBarX-ca10799b.js';
import { i as isLayoutViewport } from './isLayoutViewport-67a7f7f1.js';

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

export { getViewportRect as g };
//# sourceMappingURL=getViewportRect-562c9691.js.map
